var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19.219 23.195",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pdf_icon",
    "data-name": "Pdf icon",
    transform: "translate(37.059 -92.749)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g899",
    transform: "translate(-37.059 92.749)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g876",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_8",
    "data-name": "Union 8",
    d: "M3.149,23.2A3.153,3.153,0,0,1,0,20.045V3.15A3.153,3.153,0,0,1,3.149,0H12.87a3.468,3.468,0,0,1,1.3.262,3.524,3.524,0,0,1,.958.618L15.149.9,18.4,4.092a3.215,3.215,0,0,1,.588.872,2.785,2.785,0,0,1,.224,1.218V20.045a3.153,3.153,0,0,1-3.149,3.15Z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect2684",
    d: "M-48.929,187.119h9.694a2.064,2.064,0,0,1,.671.125,1.839,1.839,0,0,1,.467.3h0l3.2,3.137a1.765,1.765,0,0,1,.286.413,1.567,1.567,0,0,1,.08.478c0,.005,0,.01,0,.015v13.908a1.466,1.466,0,0,1-1.477,1.477H-48.929a1.466,1.466,0,0,1-1.477-1.477V188.6a1.466,1.466,0,0,1,1.477-1.477Z",
    transform: "translate(52.077 -185.446)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2697",
    d: "M-35.349,210.391c-.5-.5.041-1.18,1.5-1.906l.919-.457.358-.783c.2-.431.491-1.133.653-1.562l.295-.779-.2-.576a4.117,4.117,0,0,1-.18-2.156c.215-.518.918-.465,1.2.09a3.512,3.512,0,0,1-.063,2.212l-.211.813.186.316a10.973,10.973,0,0,0,.665.917l.495.615.616-.08c1.956-.255,2.625.179,2.625.8,0,.785-1.535.85-2.825-.056a3.919,3.919,0,0,1-.489-.406s-.808.164-1.205.272-.615.18-1.217.383c0,0-.211.306-.348.529a5.7,5.7,0,0,1-1.535,1.765A1.047,1.047,0,0,1-35.349,210.391Zm.78-.279a5.883,5.883,0,0,0,1.237-1.463l.159-.251-.722.363c-1.115.561-1.625,1.089-1.36,1.409C-35.106,210.35-34.928,210.335-34.569,210.113Zm7.242-2.033a.42.42,0,0,0-.075-.733,2.029,2.029,0,0,0-1.059-.137c-.384.026-1,.1-1.106.127,0,0,.339.234.49.321a6.508,6.508,0,0,0,1.043.436c.351.107.554.1.708-.014Zm-2.912-1.21a7.142,7.142,0,0,1-.625-.807,4.5,4.5,0,0,1-.35-.522s-.171.548-.31.879l-.436,1.079-.127.245s.673-.221,1.015-.31c.363-.095,1.1-.239,1.1-.239Zm-.938-3.763a1.581,1.581,0,0,0-.054-.886c-.316-.345-.7-.057-.632.763a5.6,5.6,0,0,0,.182,1.038l.167.529.117-.4A10.45,10.45,0,0,0-31.177,203.106Z",
    transform: "translate(40.623 -196.762)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g858",
    transform: "translate(6.119 15.932)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path845",
    d: "M-31.067,249.125h.807a2.194,2.194,0,0,1,.628.074.737.737,0,0,1,.406.322,1.06,1.06,0,0,1,.165.6,1.09,1.09,0,0,1-.134.554.785.785,0,0,1-.361.334,1.757,1.757,0,0,1-.693.1h-.279v1.273h-.54Zm.54.418v1.137h.267a.7.7,0,0,0,.494-.134.584.584,0,0,0,.139-.435.653.653,0,0,0-.091-.363.372.372,0,0,0-.2-.172,1.255,1.255,0,0,0-.342-.033Z",
    transform: "translate(31.067 -249.125)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path847",
    d: "M-20.547,249.125h.733a1.657,1.657,0,0,1,.85.189,1.173,1.173,0,0,1,.482.561,2.021,2.021,0,0,1,.165.826,2.307,2.307,0,0,1-.148.853,1.356,1.356,0,0,1-.449.6,1.4,1.4,0,0,1-.86.229h-.774Zm.54.432v2.4h.225a.756.756,0,0,0,.683-.325,1.58,1.58,0,0,0,.213-.872q0-1.2-.9-1.2Z",
    transform: "translate(22.966 -249.125)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path849",
    d: "M-8.593,249.125h1.81v.432H-8.053v.974h1.017v.432H-8.053v1.421h-.54Z",
    transform: "translate(13.761 -249.125)",
    fill: "#333"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/PdfIcon.c2ff192892cb8adcbc51d644087884bd.svg";
export { ForwardRef as ReactComponent };